module.exports = __webpack_public_path__ + "media/images/kds/KDS-7a4bc35d5f4cafca5a35b9dd9ed38483.svg";